import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorPolicyService } from '@mri-platform/angular-error-handling';
import { DefaultDataServiceConfig } from '@ngrx/data';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import { firstValueFrom, tap } from 'rxjs';
import { AuditLogFilter, FileType, JobUsageFilters } from '../models';

@Injectable({ providedIn: 'root' })
export class AuditService {
  constructor(
    private readonly apiConfig: DefaultDataServiceConfig,
    private readonly http: HttpClient,
    private readonly errorPolicyService: ErrorPolicyService
  ) {}

  async downloadUsageReport(filters: Omit<JobUsageFilters, 'allClients' | 'allDates'>) {
    const url = `${this.apiConfig.root}/audit/usage`;
    await firstValueFrom(this.downloadFile(url, filters, 'usage_report'));
  }

  async downloadAuditLogs(filters: AuditLogFilter) {
    const url = `${this.apiConfig.root}/audit/logs`;
    await firstValueFrom(this.downloadFile(url, filters, 'Audit_logs'));
  }

  private downloadFile(url: string, filters: JobUsageFilters | Partial<AuditLogFilter>, saveAsName?: string) {
    return this.http.post(url, filters, { responseType: 'blob' }).pipe(
      tap(blob => saveAs(blob, `${saveAsName}_${format(new Date(), 'ddMMyyyyHHmmss')}.${FileType.Csv}`)),
      this.errorPolicyService.catchHandle()
    );
  }
}
